import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const Desuscripcion = () => {

    const { id, firma } = useParams();

    const [status, setStatus] = useState('cargando'); // 'cargando' | 'exito' | 'error'

    useEffect(() => {
        const desuscribir = async () => {
            try {
                await axios.get(`${process.env.REACT_APP_API_ROUTE}/auth/desuscripcion/${id}/${firma}`);
                setStatus('exito');
            } catch {
                setStatus('error');
            }
        };

        if(id && firma){
            desuscribir();
        } else {
            setStatus('error');
        }
    }, []);

    return (
        <main className="main">
            <section className="section light-background">
                <div className="container py-5" data-aos="fade-up">
                    <div className="row justify-content-center py-5">
                        <div className="col-lg-6 text-center py-5">

                            {status === 'cargando' && (
                                <div className="pt-4">
                                    <div className="spinner-border text-primary mb-3" role="status">
                                        <span className="visually-hidden">Cargando...</span>
                                    </div>
                                    <p className="text-light">Procesando tu solicitud...</p>
                                </div>
                            )}

                            {status === 'exito' && (
                                <div className="pt-4">
                                    <i className="bi bi-check-circle-fill text-success" style={{ fontSize: '3rem' }}></i>
                                    <h3 className="mt-3 mb-2">Desuscripción exitosa</h3>
                                    <p className="text-light">
                                        Te has desuscrito correctamente. Ya no recibirás correos de Goodlic.
                                    </p>
                                </div>
                            )}

                            {status === 'error' && (
                                <div className="pt-4">
                                    <i className="bi bi-x-circle-fill text-danger" style={{ fontSize: '3rem' }}></i>
                                    <h3 className="mt-3 mb-2">Enlace no válido</h3>
                                    <p className="text-light">
                                        El enlace no es válido o ya fue utilizado.
                                    </p>
                                </div>
                            )}

                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
};

export default Desuscripcion;
